import { Footer, Header } from './components';
import { FiltersContainer, Search } from './filters';
import { NexelemTableRoot } from './NexelemTableRoot';
import { Table } from './Table';

export type * from './tanstack-table.d.ts';
export { useTableInfiniteQuery } from './utils';
export { useFilterController, tableFilterName } from './filters';

export { createTableInfiniteDataSource } from './utils/createTableInfiniteDataSource';
export { createColumnHelper } from './createColumnHelper';

export { tableTranslations } from './translations';
export { useSaveViewStore } from './saveViewFeature';
export type { Row } from '@tanstack/react-table';

export const NexelemTable = {
  Root: NexelemTableRoot,
  Table: Table,
  FiltersContainer: FiltersContainer,
  Footer: Footer,
  Header: Header,
  Search: Search,
};
